import { useEffect } from 'react';

const useTelegramMainButton = ({ text, onClick, isVisible = true, isEnabled = true, showProgress = false }) => {
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (tg?.MainButton) {
      if (isVisible) {
        tg.MainButton.setText(text);
        tg.MainButton.show();

        if (showProgress) {
          tg.MainButton.showProgress();
        } else {
          tg.MainButton.hideProgress();
        }

        if (isEnabled) {
          tg.MainButton.enable();
        } else {
          tg.MainButton.disable();
        }

        const handleClick = () => {
          onClick();
        };

        tg.MainButton.onClick(handleClick);

        return () => {
          tg.MainButton.offClick(handleClick);
          tg.MainButton.hide();
        };
      } else {
        tg.MainButton.hide();
      }
    }
  }, [text, onClick, isVisible, isEnabled, showProgress]);

  return !!(window.Telegram?.WebApp?.MainButton && isVisible);
};

export default useTelegramMainButton;
